import { render, staticRenderFns } from "./webadresi.vue?vue&type=template&id=59ce2382&"
import script from "./webadresi.vue?vue&type=script&lang=js&"
export * from "./webadresi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports